import { RootStateOrAny } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { v4 as generateUUID } from 'uuid';
import { ignoreHeadersByKey } from 'fetchye';
import { oneFetchye } from 'fetchye-one-app';
import { Dispatch } from 'react';
import {
  oneDataFetchye,
  oneErrorOnNotOkFetchye,
} from '@americanexpress/fetchye-amex';
import {
  getMembershipDomainApiUrl,
  getNavigationOneCmsUrlSelector,
  getPersonaApiUrl,
} from '../selectors/apiSelectors';
import { MODULE_NAME } from '../constants/commonConstants';
import { MEMBERSHIP_DOMAIN_QUERY, membershipDomainHeaders } from '../graphql/membershipQuery';
import { graphqlFetcher } from '../graphql/graphqlFetcher';
import { NavigationLinks } from '../types/NavigationLinks';
import {
  fetchyeOpts,
  generateReporting,
  getPersonaAccounts,
  personaHeaders,
} from '../utils/apiUtils';
import { HTTP_METHODS } from '../constants/apiConstants';

export const isLoggedInThunk: RootStateOrAny = async (dispatch: Dispatch<unknown>) => {
  const { data } = await dispatch(oneDataFetchye('ReadUserSession.v1', { method: 'GET' })) as RootStateOrAny;
  return !!data?.ok;
};

export const membershipDomainApiThunk = async (
  dispatch: RootStateOrAny,
  getState: RootStateOrAny
) => {
  const state = getState();
  const isLoggedIn = await dispatch(isLoggedInThunk);
  const activeLocale = getActiveLocaleSelector(state);
  const membershipDomainApiUrl = getMembershipDomainApiUrl(state);

  const fetcherOpts = {
    reporting: {
      moduleID: MODULE_NAME,
      component: 'membershipDomainApiThunk',
      fetch: {
        url: membershipDomainApiUrl,
        activeLocale,
      },
    },
  };

  return isLoggedIn && dispatch(
    oneFetchye(
      { query: MEMBERSHIP_DOMAIN_QUERY },
      {
        ...membershipDomainHeaders({ correlationId: generateUUID(), locale: activeLocale }),
        mapOptionsToKey: ignoreHeadersByKey(['X-User-Auth', 'X-Correlation-Id', 'X-Timestamp']),
      },
      graphqlFetcher(dispatch, membershipDomainApiUrl, fetcherOpts)
    )
  );
};

export const navigationLinksThunk: RootStateOrAny = async (
  dispatch: Dispatch<unknown>,
  getState: () => RootStateOrAny
) => {
  const state = getState();

  return dispatch(
    oneErrorOnNotOkFetchye<NavigationLinks>(
      `${getNavigationOneCmsUrlSelector(state)}`,
      fetchyeOpts,
      generateReporting(
        'src/thunks/navigationLinksThunk'
      )
    )
  );
};

export const personaApiThunk: RootStateOrAny = async (
  dispatch: Dispatch<unknown>,
  getState: () => RootStateOrAny
) => {
  const state = getState();
  const locale = getActiveLocaleSelector(state);
  const { data: membershipApiData } = await dispatch(membershipDomainApiThunk) as RootStateOrAny;
  const cards = getPersonaAccounts(membershipApiData);
  return cards && dispatch(
    oneErrorOnNotOkFetchye(
      `${getPersonaApiUrl(state)}`,
      {
        ...personaHeaders(locale),
        method: HTTP_METHODS.POST,
        credentials: 'include',
        body: JSON.stringify({
          cards,
        }),
      },
      generateReporting(
        'src/thunks/personaApiThunk'
      )
    )
  );
};
